// extracted by mini-css-extract-plugin
export var fullGrid = "_2v-3";
export var pdpPreviewContainer = "_2v-1";
export var previewContainer = "_2v-0";
export var togglePreviewContainer = "_2v-2";